export const DEFAULT_LOCALE = 'en';

export const AVAILABLE_LOCALES = ['en', 'nl', 'es', 'fr'];
